if (!customElements.get('quote-slideshow')) {
    class QuoteComponent extends HTMLElement {
      constructor() {
        super();
  
        this.slideshow = this.querySelector('.splide');
        this.slideshowList = this.slideshow.querySelector('.splide__list');
  
        this.initSlideshow();
      }
  
      initSlideshow() {
        this.options = JSON.parse(this.slideshow.dataset.options);
  
        this.Splide = new theme.Splide(this.slideshow, this.options);
  
        this.Splide.on('mounted', () => {
          this.onResize();
        });
  
        this.Splide.mount();
  
        this.bindEditorEvents();
      }
  
      onResize() {
        this.slideshowResizeObserver = new ResizeObserver((entries) => {      
          const activeSlideImage = this.slideshow.querySelector(
            '.splide__slide.is-active .slide__quote'
          );
          console.log(theme.Splide.STATES);
          if (this.Splide.state.is(theme.Splide.STATES.IDLE )) {
            this.slideshowList.style.height = `${activeSlideImage.offsetHeight}px`;
          }
        });
  
        this.slideshowResizeObserver.observe(this.slideshow);
      }
   
      bindEditorEvents() {
        const {Autoplay} = this.Splide.Components;
  
        document.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail.blockId;
          const selectedBlock = this.slideshow.querySelector(
            `[data-block-id="${blockId}"]`
          );
          if (selectedBlock) {
            const slideIndex = Number(selectedBlock.dataset.slideIndex);
            this.Splide.go(slideIndex);
          }
        });
  
        document.addEventListener('shopify:section:select', (event) => {
          Autoplay.pause();
        });
  
        document.addEventListener('shopify:section:deselect', (event) => {
          Autoplay.play();
        });
      }
    }
    customElements.define('quote-slideshow', QuoteComponent);
  }
  